module.exports = __webpack_public_path__ + "img/7.933e61e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.jpg
// module id = 211
// module chunks = 1